import React from 'react';

import { useFlowState } from '@betterment/js-runtime';
import { Banner, Box, Button, Card, ContentLayoutF, H2, Text } from '@betterment/samba-react';
import { Form, Formik } from 'formik';

import { pluralize } from '../../../../utils/strings/strings';
import FlowStepLayout from '../../../BettermentForAdvisors/FlowStepLayout';
import AffectedHouseholdsTable from '../affected-households-table/AffectedHouseholdsTable';
import { BillingPlanFlowValues } from '../data';
import { useSubmitHandler } from '../hooks/useSubmitHandler';
import { getFlowTitle } from '../utils';

export const ReviewAffectedHouseholds: React.FC = () => {
  const {
    flowState: { values: flowValues },
  } = useFlowState<BillingPlanFlowValues>();
  const { submitHandler, errorMessage } = useSubmitHandler();

  return (
    <FlowStepLayout exitToPath={flowValues.exitToPath} title={getFlowTitle(flowValues, 3)}>
      <Box
        css={{
          width: 'container.max',
          minHeight: 'calc(100vh - 220px)',
          justifySelf: 'center',
        }}
      >
        <Box css={{ pb: 'space.400' }}>
          {/* @ts-expect-error TS2345 violates strict null checks */}
          <H2>Review changes to {pluralize(flowValues.numberOfClients, 'client')}.</H2>
          {errorMessage && (
            <Banner variant="critical" css={{ mt: 'space.400' }}>
              <Banner.Content>{errorMessage}</Banner.Content>
            </Banner>
          )}
        </Box>
        <Formik
          initialValues={flowValues}
          onSubmit={async (values: BillingPlanFlowValues) => {
            await submitHandler(values);
          }}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <ContentLayoutF>
                <ContentLayoutF.SlotContainer>
                  <ContentLayoutF.Slot1>
                    <AffectedHouseholdsTable
                      numberOfClients={flowValues.numberOfClients!}
                      billingPlanId={flowValues.billingPlanId!}
                    />
                  </ContentLayoutF.Slot1>
                  <ContentLayoutF.Slot2>
                    <Card
                      css={{
                        width: 'container.medium',
                        padding: 'space.300',
                        borderStyle: 'solid',
                        borderWidth: 'thin',
                        borderColor: 'border',
                        boxShadow: 'none',
                        position: 'sticky',
                        top: '20px',
                      }}
                    >
                      <Card.Content>
                        <Text>
                          Changes made to this plan will apply to {values.numberOfClients === 1 ? 'this' : 'these'}{' '}
                          {/* @ts-expect-error TS2345 violates strict null checks */}
                          {pluralize(values.numberOfClients, 'client')} going forward. Previous recordkeeping will
                          reflect the plan's prior settings.
                        </Text>
                      </Card.Content>
                      <Card.Footer css={{ pt: 'space.300' }}>
                        <Button type="submit" disabled={isSubmitting} css={{ width: '100%' }}>
                          Update plan
                        </Button>
                      </Card.Footer>
                    </Card>
                  </ContentLayoutF.Slot2>
                </ContentLayoutF.SlotContainer>
              </ContentLayoutF>
            </Form>
          )}
        </Formik>
      </Box>
    </FlowStepLayout>
  );
};
